export const showCompany = (state) => state.company
export const showPayments = (state) => state.payments
export const showUrl = (state) => state.url
export const showPrice = (state) => state.price
